<template>
  <div class="container">
    <div class="topbar">
      <div class="leftTitle">
        <h3>访客来源统计</h3>
      </div>
      <div class="button-group">
        <a-range-picker
          class="range-picker lianedate"
          @change="changeDate"
          :value="chooseDate"
          :disabledDate="disabledDate"
        >
          <template slot="renderExtraFooter"></template>
        </a-range-picker>
        <a-button-group>
          <a-button :type="buttonTypeOne" @click="ChooseDateButtonOne()">一周</a-button>
          <a-button :type="buttonTypeTwo" @click="ChooseDateButtonTwo()">十五天</a-button>
          <a-button :type="buttonTypeThree" @click="ChooseDateButtonThree()">一个月</a-button>
        </a-button-group>
      </div>
    </div>
    <bar :dataSource="dataSource" :height="420"/>
    <!-- <div class="chart">
      <div class="leftchart">
        <h4>模板使用量TOP 5</h4>
        <not-date v-if="data.length == 0"></not-date>
        <a-skeleton active :loading="loadingTemplate" v-else>
          <v-chart :forceFit="true" :height="height" :data="data" :padding="padding">
            <v-coord type="rect" direction="LB" />
            <v-tooltip :shared="true" />
            <v-axis dataKey="smsType" :label="label" :tickLine="tickLine" />
            <v-interval position="smsType*smsNum" :label="labelInterval" />
          </v-chart>
        </a-skeleton>
      </div>
      <div class="rightchart">
        <h4>来源发送量TOP 5</h4>
        <not-date v-if="data2.length == 0"></not-date>
        <a-skeleton active :loading="loadingSource" v-else>
          <v-chart :forceFit="true" :height="height" :data="data2" :padding="padding">
            <v-coord type="rect" direction="LB" />
            <v-tooltip :shared="true" />
            <v-axis dataKey="smsNum" :label="label" :tickLine="tickLine" />
            <v-interval position="smsType*smsNum" :label="labelInterval" />
          </v-chart>
        </a-skeleton>
      </div>
    </div> -->
  </div>
</template>


<script>
import moment from 'moment'
import { templateTop5Count, newsSourceTop5Count, getAnalysisSourceData } from '@/api/api'
import notDate from './notDate'
import Bar from '@/components/chart/Bar'

const label = {
  textStyle: {
    fill: '#8d8d8d',
  },
  offset: 10,
}

const tickLine = {
  alignWithLabel: false,
  length: 0,
}

const labelInterval = [
  'smsNum',
  {
    useHtml: true,
    htmlTemplate: function htmlTemplate(text, item) {
      var a = item.point
      return '<span class="g2-label-item"><p class="g2-label-item-value">' + a.smsNum + '</p></div>'
    },
  },
]

export default {
  components: {
    notDate,Bar
  },
  data() {
    return {
      data: [],
      data2: [],
      label,
      tickLine,
      labelInterval,
      height: 200,
      buttonTypeOne: '',
      buttonTypeTwo: '',
      buttonTypeThree: '',
      chooseDate: [
        moment(moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD'),
        moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD'),
      ],
      parmsDate: [],
      padding: [20, 'auto'],
      loadingTemplate: false,
      loadingSource: false,
      dataSource: []
    }
  },
  mounted() {
    this.ChooseDateButtonOne()
  },
  methods: {
    disabledDate(current) {
      return current > moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
    },
    ChooseDateButtonOne() {
      this.buttonTypeOne = 'primary'
      this.buttonTypeTwo = ''
      this.buttonTypeThree = ''
      this.parmsDate[0] = moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD')
      this.parmsDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.chooseDate[0] = moment(moment(new Date()).subtract(6, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.chooseDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getTemplateDate()
      this.getSourceDate()
    },
    ChooseDateButtonTwo() {
      this.buttonTypeOne = ''
      this.buttonTypeTwo = 'primary'
      this.buttonTypeThree = ''
      this.parmsDate[0] = moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD')
      this.parmsDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.chooseDate[0] = moment(moment(new Date()).subtract(14, 'day').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.chooseDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getTemplateDate()
      this.getSourceDate()
    },
    ChooseDateButtonThree() {
      this.buttonTypeOne = ''
      this.buttonTypeTwo = ''
      this.buttonTypeThree = 'primary'
      this.parmsDate[0] = moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD')
      this.parmsDate[1] = moment(new Date()).format('YYYY-MM-DD')
      this.chooseDate[0] = moment(moment(new Date()).subtract(1, 'month').format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.chooseDate[1] = moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      this.getTemplateDate()
      this.getSourceDate()
    },
    changeDate(dates, dateStrings) {
      this.chooseDate = dates
      this.parmsDate[0] = dateStrings[0]
      this.parmsDate[1] = dateStrings[1]
      this.buttonTypeOne = ''
      this.buttonTypeTwo = ''
      this.buttonTypeThree = ''
      this.getSourceDate()
      this.getTemplateDate()
    },
    getTemplateDate() {
      this.loadingTemplate = true
      let params = {
        endTime: this.parmsDate[1],
        startTime: this.parmsDate[0],
      }
      templateTop5Count(params).then((res) => {
        if (res.success) {
          this.data = res.result
          this.loadingTemplate = false
        } else {
          // this.ChooseDateButtonOne()
        }
      })
    },
    getSourceDate() {
      this.loadingSource = true
      let params = {
        endTime: this.parmsDate[1],
        startTime: this.parmsDate[0],
      }
      getAnalysisSourceData(params).then((res) => {
          console.log('getAnalysisSourceData',res)
        if (res.success) {
          this.dataSource = res.result
          this.loadingSource = false
        } else {
          // this.ChooseDateButtonOne()
        }
      })
    },
  },
}
</script>

<style scoped>
.container {
  padding-top: 10px;
  margin-left: 1%;
  width: 100%;
}
.leftchart {
  width: 45%;
  height: 100%;
  margin-right: 5%;
  display: inline-block;
}
.rightchart {
  width: 45%;
  height: 100%;
  display: inline-block;
}

.topbar {
  height: 100%;
  width: 98%;
}

.leftTitle {
  height: 100%;
  width: 49%;
  margin-top: 1%;
  margin-left: 1%;
  display: inline-block;
}
.chart {
  height: 100%;
  width: 99%;
  margin-top: 2%;
  background-color: #ffffff;
  margin-left: 1.5%;
}
.button-group {
  height: 100%;
  width: 49%;
  display: inline-block;
  text-align: right;
}
.range-picker {
  width: 35%;
  margin-right: 3%;
}
</style>
